export default __webpack_public_path__ + "static/media/jolt-100-3.5c7daee5.jpg";